import React, { PureComponent } from "react";

import Loader from "./../../Loader/Loader.js";
import { Metric, selectFormat } from "./../../Utils/Utils.js";

import Heading from "./../../Elements/Heading";

class YoutubeKeyStatsRevenue extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      {
        Metric: "Total Unique Videos Published",
        Value: selectFormat(
          "number",
          this.props.data.metrics.videos_published.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Video Views",
        Value: selectFormat(
          "number",
          this.props.data.metrics.views.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Revenue (est)",
        Value: selectFormat(
          "currency-GB",
          this.props.data.metrics.revenue.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Ad Revenue (est)",
        Value: selectFormat(
          "currency-GB",
          this.props.data.metrics.ad_revenue.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Red Revenue (est)",
        Value: selectFormat(
          "currency-GB",
          this.props.data.metrics.red_revenue.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Ad Impressions",
        Value: selectFormat(
          "number",
          this.props.data.metrics.ad_impressions.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Monetized Playbacks",
        Value: selectFormat(
          "number",
          this.props.data.metrics.monetized_playbacks.value,
          "0,0"
        ),
      },
      {
        Metric: "Overall CPM",
        Value: selectFormat("currency-GB", this.props.data.metrics.cpm.value),
      },
    ],
    opts: {
      type: "other",
    },
  });
  render() {
    const { loading } = this.props;

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />;
    }

    const data = this.props.data;

    return (
      <>
        <div className="row mb-3">
          <div className="col-lg-3 col-md-3 col-sm-6 col-6">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Total Unique Videos Published</Heading>

                <Metric {...data.metrics.videos_published} size={"md"} />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4 mb-md-0">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Total Video Views</Heading>
                <Metric {...data.metrics.views} size={"md"} />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-6 col-6">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Total Revenue (est)</Heading>
                <Metric
                  {...data.metrics.revenue}
                  size={"md"}
                  type={"currency-GB"}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4 mb-md-0">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Total Ad Revenue (est)</Heading>
                <Metric
                  {...data.metrics.ad_revenue}
                  size={"md"}
                  type={"currency-GB"}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-5 mb-4">
          <div className="col-lg-3 col-md-3 col-sm-6 col-6">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Total Red Revenue (est)</Heading>
                <Metric
                  {...data.metrics.red_revenue}
                  size={"md"}
                  type={"currency-GB"}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-6 col-6">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Total Ad Impressions</Heading>
                <Metric {...data.metrics.ad_impressions} size={"md"} />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-6 col-6">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Total Monetized Playbacks</Heading>
                <Metric
                  {...data.metrics.monetized_playbacks}
                  size={"md"}
                  tooltip
                />
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-6 col-6">
            <div className="row row--header">
              <div className="col-12">
                <Heading size={5}>Overall CPM</Heading>
                <Metric
                  {...data.metrics.cpm}
                  size={"md"}
                  type={"currency-GB"}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default YoutubeKeyStatsRevenue;
